/* ================================================== */
/* HAMBURGER
/* ================================================== */

function toggleHamburger($el) {
	if ($el.length) $el.attr('data-open', ($el.attr('data-open') == 'false') ? 'true' : 'false');
}